// Olympe
import { useProperty } from '@olympeio/core';

/**
 * @param {!BrickContext} $
 * @return {!Observable}
 */
export function initTriggers($) {
    return $.observe('Reload', false);
}

/**
 * @param {!BrickContext} $
 */
export function useRedraw($) {
    useProperty($, 'Redraw');
}

/**
 * @param {!BrickContext} $
 */
export function triggerRedraw($) {
    $.trigger('Redraw');
}

/**
 * @param {!BrickContext} $
 */
export function triggerReload($) {
    $.trigger('Reload');
}

